---
title: 🔰 Newbie Field Day Training & Overnight Hangout 📻
date: 2026-05-23
endDate: 2026-05-24
location: TBD
description: New to ham radio — or just want a refresher? Join us for hands-on training covering phonetics, net control, radio programming, and emergency comms, followed by an overnight hangout with HF operating, a cookout, and great company. All are welcome.
published: true
featured: true
# coordinates: XX.XXXXXX, -XXX.XXXXXX
---

# 🔰 Newbie Field Day Training & Overnight Hangout 📻

Whether you just passed your license exam, have been licensed for years but want more practice, or are just curious about amateur radio — this event is for you. We're combining a focused training session with a relaxed overnight hangout and cookout. Bring yourself, bring a friend, and come learn something new.

---

## 📅 Event Schedule

- **Arrive & Set Up — Saturday, May 23 @ ~11:00 AM PDT**
  - Help us get the cookout and operating stations ready
- **Newbie Training Session — Saturday, May 23 @ 2:00 PM – 4:00 PM PDT**
  - Phonetics and proper radio procedure
  - Net control operations
  - How to program your radio
  - Emergency communications basics (ARES/AUXCOMM oriented)
  - Q&A — no question is too basic
- **Evening Hangout — Saturday, May 23 @ ~4:00 PM PDT onward**
  - HF voice and digital operating
  - MURS demos for the whole family
  - Cookout, good conversation, and radio nerdery
- **Wrap Up & Departure — Sunday, May 24 @ ~12:00 PM PDT**

---

## 📍 Location

> **Location is TBD.** Check back here, watch our [Discord](https://discord.gg/432vsVAuwZ) general channel, or use our [contact form](/contact) for updates.

<!-- Once location is confirmed, uncomment and fill in the map below:

**Exact Address:** [Address here]

<div class="my-6">
  <iframe
    src="https://www.google.com/maps/embed?pb=PASTE_EMBED_URL_HERE"
    width="100%"
    height="450"
    style="border:0;"
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
    class="rounded-lg shadow"
  ></iframe>
</div>

-->

---

## 🎯 What We'll Cover in Training

The training session is designed to be practical and accessible regardless of your license class or experience level:

- **Phonetics** — NATO alphabet and proper radio voice procedure
- **Net operations** — How to check in, how to run net control
- **Radio programming** — Getting your handheld or mobile radio set up
- **Emergency communications** — Introduction to ARES/AUXCOMM concepts and why it matters
- **Open Q&A** — Ask anything; we love questions

The hangout afterward keeps the learning going in a more relaxed setting — HF voice, digital modes, and hands-on time with equipment.

---

## 🧰 What to Bring

**For the training and operating:**
- Your radio and laptop if you have them — we'll have some club radios available
- Notebook and pen if you like taking notes
- Bring a friend or family member — even non-hams are welcome!

**For the overnight:**
- Whatever you'd bring for a walk in the woods or camping
- Proper attire for outdoor conditions and layering for the evening
- Plenty of hydration
- Snacks, drinks, and extra food are always appreciated — we'll have some, but more is more

> We will have MURS radios on hand that anyone can use — no license required. Great for kids, spouses, or anyone curious about radio.

---

## 🍖 Food & Atmosphere

We'll be cooking out, so there will be food. Bringing something to share is always welcome but never required. We are a welcoming club — adults may bring their own beverages. We keep it friendly and inclusive for all ages.

---

## 📬 Questions & More Info

- **Discord:** Join the [DSARC Discord](https://discord.gg/432vsVAuwZ) and ask in the `#general` channel
- **Contact Form:** Use our [contact page](/contact) for any questions
- **Location updates** will be posted to Discord and updated here once confirmed
